import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import { capitalizeFirstLetter, detectMobile } from "../../services/utils";
import {
  FAQ_CATEGORY_CLICK,
  FAQ_QUESTION_CLICK
} from "../../services/webengage/webEngageConstants";
import styles from "./styles";
import CustomAccordian from "../../components/CustomAccordian";
import cns from "classnames";
import LazyLoader from "../../lib/lazyLoader";
class FaqAccordion extends Component {
  constructor(props) {
    super(props);
    props.faqList.map(item => {
      this[`${item.category}_ref`] = React.createRef();
    });
    this.state = {
      expanded: "faqabout-us0",
      activeMenu: "",
      isSticky: false,
      isHash: false
    };
  }

  componentDidMount() {
    document.addEventListener("scroll", this.handleScroll);

    let currentLocation = window.location;
    if (currentLocation.hash) {
      let id = currentLocation.hash.substring(1);
      this.setState({
        activeMenu: id,
        expanded: `faq${id}0`,
        isHash: true
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const height = detectMobile() ? 160 : 100;

    const { faqList } = this.props;

    let activeMenu = "";

    const scrollMargin = 270;

    for (let i = 0; i < faqList.length; ++i) {
      const item = faqList[i];
      const element = this[`${item.category}_ref`].current;

      const scrollHeight = window.pageYOffset;
      const elementPosition =
        element.offsetTop + element.clientHeight - scrollMargin;

      if (elementPosition > scrollHeight) {
        activeMenu = item.category.toLowerCase().replace("_", "-");
        break;
      }
    }

    if (!activeMenu) {
      const item = faqList[faqList.length - 1];
      activeMenu = item.category.toLowerCase().replace("_", "-");
    }

    const isSticky = window.scrollY < height ? false : true;
    const isHash = window.scrollY < 100 ? false : this.state.isHash;
    this.setState({
      isSticky,
      isHash,
      activeMenu
    });
  };

  getFormatedTitle = string => {
    let titleList = string.split("_");
    let title = "";
    if (titleList.length > 0) {
      for (var i = 0; i < titleList.length; i++)
        title += capitalizeFirstLetter(titleList[i].toLowerCase()) + " ";
    } else {
      title = capitalizeFirstLetter(titleList.toLowerCase());
    }
    return title;
  };

  handleChange = (category, index, question) => {
    const newExpandedId = `faq${category
      .toLowerCase()
      .replace("_", "-")}${index}`;
    this.setState({
      expanded: this.state.expanded === newExpandedId ? null : newExpandedId
    });
  };

  scrollToElement = category => {
    this.setState({
      activeMenu: category.toLowerCase().replace("_", "-"),
      expanded: `faq${category.toLowerCase().replace("_", "-")}0`,
      isHash: true
    });

    // this.props.logEvents(FAQ_CATEGORY_CLICK, { category: category });
  };

  renderFaqItem = () => {
    const { classes, faqList } = this.props;
    const { activeMenu } = this.state;
    return faqList.map((item, index) => {
      return item.category ? (
        <a
          href={`#${item.category.toLowerCase().replace("_", "-")}`}
          className={classes.menuItem}
          key={`faq${index}`}
          onClick={() => this.scrollToElement(item.category)}
        >
          {activeMenu === item.category.toLowerCase().replace("_", "-") ? (
            <span className={classes.activeMenuItem}>
              {this.getFormatedTitle(item.category)}
            </span>
          ) : index === 0 && !activeMenu ? (
            <span className={classes.activeMenuItem}>
              {this.getFormatedTitle(item.category)}
            </span>
          ) : (
            this.getFormatedTitle(item.category)
          )}
        </a>
      ) : null;
    });
  };

  renderQuestionsAnswer = () => {
    const { classes, faqList } = this.props;
    const { expanded, isSticky, isHash } = this.state;
    return (
      <>
        {faqList.map((item, index) => {
          return (
            <div
              id={item.category.toLowerCase().replace("_", "-")}
              key={`faq-${index}`}
              className={classes.faqSection}
            >
              <div
                className={classes.faqList}
                key={`cat${item.category}`}
                ref={this[`${item.category}_ref`]}
              >
                {item.category && (
                  <div className={classes.catTitle}>
                    <img
                      data-src={`/hire/faq-${item.category}.webp`}
                      alt={item.category.replace("_", " ")}
                    />
                    <h2 className={classes.categoryName}>
                      {item.category.replace(/_/g, " ")}
                    </h2>
                  </div>
                )}
                {item.faq &&
                  item.faq.map((faqItem, index) => {
                    return (
                      <CustomAccordian
                        summary={`Q${index + 1}) ${faqItem.question}`}
                        details={faqItem.answer}
                        key={`faq-${index}`}
                        expanded={
                          expanded ===
                          `faq${item.category
                            .toLowerCase()
                            .replace("_", "-")}${index}`
                        }
                        onChange={() =>
                          this.handleChange(
                            item.category,
                            index,
                            faqItem.question
                          )
                        }
                      />
                    );
                  })}
              </div>
            </div>
          );
        })}
      </>
    );
  };

  render() {
    const { classes = true } = this.props;
    const { isSticky } = this.state;

    return (
      <div
        className={classes.faqContainer}
        itemScope
        itemType="https://schema.org/FAQPage"
      >
        <div
          className={
            isSticky
              ? cns(classes.stickyClass, classes.faqContainerLeft)
              : classes.faqContainerLeft
          }
        >
          <div className={classes.faqTab}>{this.renderFaqItem()}</div>
        </div>
        <div className={classes.faqContainerRight}>
          {this.renderQuestionsAnswer()}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(LazyLoader(FaqAccordion));
